import sendQuery from '../../core/storefrontAPI/send-query';
import { getCookie } from '../../core/helpers';

export default class CartPageDiscount {
  cartSummaryDesktop;
  cartSummaryMobile;
  elements;
  promoCodesList;
  cartID;

  // Note that the "order summary" gets duplicated (desktop / mobile)
  constructor() {
    this.cartSummaryDesktop = document.querySelector('[data-cart-summary="desktop"]');
    this.cartSummaryMobile = document.querySelector('[data-cart-summary="mobile"]');

    this.elements = {
      discountContainerAll: document.querySelectorAll('[data-cart-discount]'),
      codeItemsAll: document.querySelectorAll('[data-cart-discount-code-item]'),
      codeItemsDesktop: this.cartSummaryDesktop.querySelectorAll('[data-cart-discount-code-item]'),
      codeItemsMobile: this.cartSummaryMobile.querySelectorAll('[data-cart-discount-code-item]'),
      removeCodeButtons: document.querySelectorAll('[data-cart-discount-code-remove]'),
    };

    this.promoCodesList = [];
    this.getCartId = this.getCartId();

    this.init();
  }

  init = () => {
    // Not supported if cart ID isn't available from Shopify Cookie OR we don't have the cart json data
    if (this.getCartId.length === 0 || typeof ShopifyCartData === 'undefined' || ShopifyCartData === null) {
      // Remove the promo code field
      this.cartSummaryDesktop.querySelector('[data-cart-discount]').remove();
      this.cartSummaryMobile.querySelector('[data-cart-discount]').remove();
      return;
    }

    if (this.elements.removeCodeButtons.length > 0) {
      Array.from(this.elements.removeCodeButtons).forEach((element) => {
        element.addEventListener('click', this.removeCode.bind(this));
      });
    }

    if (this.elements.discountContainerAll.length > 0) {
      Array.from(this.elements.discountContainerAll).forEach((element) => {
        element.querySelector('[data-cart-discount-code-submit]').addEventListener('click', this.addCode.bind(this));
      });
    }

    // await this.loadCurrentCodes();
    this.getPromoCodesFromCart();
  };

  getPromoCodesFromCart = () => {
    // Cart level discounts
    this.promoCodesList = ShopifyCartData.cart_level_discount_applications.map(item => item.title);

    // Line item level discounts
    ShopifyCartData.items.forEach(item => {
      if (item.line_level_discount_allocations.length > 0) {
        item.line_level_discount_allocations.forEach(discount => {
          if (!this.promoCodesList.includes(discount.discount_application.title)) {
            this.promoCodesList.push(discount.discount_application.title);
          }
        });
      }
    });
  };

  /* Retrieve the cart ID from the Shopify Cookie, it will be needed to make the Storefront API requests */
  getCartId = () => {
    const cart_cookie = getCookie('cart');
    if (cart_cookie === '') {
      return '';
    }

    return `gid://shopify/Cart/${getCookie('cart')}`;
  };

  /* Disable/enable elements; add/remove loading status... */
  setBusyState = (is_busy) => {
    Array.from(this.elements.discountContainerAll).forEach((element) => {
      (is_busy) ? element.classList.add('loading') : element.classList.remove('loading');
    });
  };

  /*
  loadCurrentCodes = async () => {
    const query = `
      query GetDiscountCodesFromCart {
        cart(id: "${this.getCartId}") {
          discountCodes {
            applicable
            code
          }
          discountAllocations {
            discountedAmount {
              amount
            }
          }
        }
      }
    `;

    console.log(`[ASTR] query`, query);
    const response = await sendQuery(query);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return null;
    }

    const response_json = await response.json();

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return null;
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return null;
    }

    console.log('Storefront API data', response_json.data);
  };
  */

  /* Update the cart discount using the Storefront API */
  updateCartDiscounts = async () => {
    const query = `
      mutation {
        cartDiscountCodesUpdate(
          cartId: "${this.getCartId}"
          discountCodes: [${this.promoCodesList.map(code => `"${code}"`).join(',')}]
        ) {
          cart {
            id
            discountCodes {
              code
              applicable
            }
            checkoutUrl
          }
          userErrors {
            code
            field
            message
          }
        }
      }
    `;

    // console.log(`[ASTR] query`, query);
    const response = await sendQuery(query);
    // console.log(`[ASTR] response`, response);

    if (!response.ok) {
      // throw new Error(`HTTP error ${response.status}`);
      console.log(`HTTP error ${response.status}`);
      return null;
    }

    const response_json = await response.json();

    if (typeof response_json.errors !== 'undefined') {
      console.log('[Storefront API] Error in response:', response_json.errors);
      return null;
    }

    if (typeof response_json.data === 'undefined') {
      console.log('[Storefront API] No data', response_json);
      return null;
    }

    console.log('Storefront API data', response_json.data);
    return response_json.data;
  };

  applyCodeUpdate = async (promo_section) => {
    const error_element = promo_section.querySelector('[data-cart-discount-errors]');
    error_element.innerHTML = '';
    error_element.classList.remove('active');
    let error_message = '';

    this.setBusyState(true);
    const result = await this.updateCartDiscounts();
    this.setBusyState(false);

    if (result === null) {
      error_message += `An error occured, please try later.`;
    } else {
      result?.cartDiscountCodesUpdate?.cart?.discountCodes.forEach(discount => {
        if (!discount.applicable) {
          error_message += `<strong>${discount.code}</strong> couldn't be used with your existing discounts.<br>`;
          this.promoCodesList = this.promoCodesList.filter(code => code !== discount.code);
        }
      });
    }

    if (error_message !== '') {
      error_element.innerHTML = error_message;
      error_element.classList.add('active');
      return;
    }

    // Reload the page on cart template
    // if (document.querySelector('body').classList.contains('template-cart')) {
      window.location.reload(false);
    // }
  };

  /* Remove a promo code */
  removeCode = async (e) => {
    const item = e.currentTarget;
    const promo_code = item.dataset.code;
    const promo_section = item.closest('[data-cart-discount]');
    console.log(`[ASTR] Remove promo code`, promo_code);

    if (!promo_code || promo_code.length === 0) {
      return;
    }

    // Remove the promo code from the list of codes
    this.promoCodesList = this.promoCodesList.filter(code => code !== promo_code);
    console.log('this.promoCodesList', this.promoCodesList);

    // Not really needed since we refresh the page, but visually better experience
    item.closest('[data-cart-discount-code-item]').remove();

    await this.applyCodeUpdate(promo_section);
  };

  /* Apply a promo code */
  addCode = async (e) => {
    const item = e.currentTarget;
    const promo_field = item.parentElement.querySelector('[data-cart-discount-code]');
    const promo_code = promo_field.value;
    const promo_section = item.closest('[data-cart-discount]');
    console.log(`[ASTR] Apply promo code`, promo_code);

    if (!promo_code || promo_code.length === 0 || this.promoCodesList.includes(promo_code) || promo_code.length > 20) {
      return;
    }

    // Add the promo code to the list of codes
    this.promoCodesList.push(promo_code);

    await this.applyCodeUpdate(promo_section);
  };
}
